import { useState } from "react";
import { startOfTheCurrentOrPreviousYear } from "../misc/dateUtils";
import type { CostSearchCriteria } from "./CostSearch";

export const useCostSearch = () => {
  const [costsSearch, setCostsSearch] = useState<CostSearchCriteria>({
    text: "",
    month: startOfTheCurrentOrPreviousYear(),
  });
  return { costsSearch, setCostsSearch };
};
